import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { SkillRatingConstituents } from '~/monolith-api';

export type CourseSkillsAssignee = {
   assigneeid: number;
   assigneetype: string;
   name: string;
   average_skill_rating: number;
   constituents: SkillRatingConstituents;
};

export type GetAssigneesSkilledInACourseResponse = {
   assignees: CourseSkillsAssignee[];
   hasMore: boolean;
};

type AssigneeType = 'user' | 'team';

export type GetAssigneesSkilledInACourseOptions = CommonRequestOptions & {
   query?: string;
   order?: 'DESC' | 'ASC';
   offset?: number;
   limit?: number;
   assignee_type?: AssigneeType | AssigneeType[];
};

export function getAssigneesSkilledInACourse(
   wikiid: number,
   options: GetAssigneesSkilledInACourseOptions = {}
): Promise<GetAssigneesSkilledInACourseResponse> {
   const { query, order, offset, limit, assignee_type, ...common } = options;

   return makeRequest('get', `/skills/courses/${wikiid}/assignees`, {
      ...common,
      query: {
         query,
         order,
         offset,
         limit,
         assignee_type,
      },
   });
}
